import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  background: ', ';\n  margin: auto -25px 0;\n  padding: 75px 10px 50px;\n'], ['\n  background: ', ';\n  margin: auto -25px 0;\n  padding: 75px 10px 50px;\n']);

import styled from 'styled-components';

export var StyledDiv = styled.div(_templateObject, function (props) {
  return props.theme.dormifyBackgroundGrey;
});